import { Stack, Text } from "@mantine/core";

/**
 * Stacked label/value pair used in the detail drawers (corrections, issues).
 * Renders a dimmed uppercase label above the value; a null value shows a
 * dimmed "(none)" placeholder. Pass `mono` for monospace values (ids, codes).
 */
export function DetailRow({
  label,
  value,
  mono,
}: {
  label: string;
  value: string | null;
  mono?: boolean;
}) {
  return (
    <Stack gap={4}>
      <Text size="xs" c="dimmed" tt="uppercase" fw={600} lts="0.04em">
        {label}
      </Text>
      <Text size="sm" ff={mono ? "monospace" : undefined} c={value ? undefined : "dimmed"}>
        {value ?? "(none)"}
      </Text>
    </Stack>
  );
}
